export default {
    dermx: {
        app_name: 'dermx',
        app_img: '/images/dermx_sample.png',
        // app_qrcode: '/images/dermx_qrcode.jpg',
        scenarios: [
            {
                icon: 'icontoday-24px',
                title: '预问诊',
                content: '提前对患者进行AI预诊断，减轻医疗机构压力'
            },
            {
                icon: 'iconcall_split-24px',
                title: '分诊导医',
                content: '患者分流，让互联网医疗平台更智能、更高效'
            },
            {
                icon: 'iconmenu_book-24px',
                title: '辅助问诊',
                content: '皮肤疾病百科，让医生问诊更轻松、更精准'
            },
            {
                icon: 'iconGroup5',
                title: '导药',
                content: '疾病相关用药购药推荐'
            }
        ],
        prices: [
            {
                mode: '月结｜基础',
                price: 50000,
                amt: 25000,
                qps: 5,
                excess: '2元/次',
                expire: '1个月',
                type: ''
            },
            {
                mode: '月结｜中级',
                price: 90000,
                amt: 55000,
                qps: 10,
                excess: '1.6元/次',
                expire: '1个月',
                type: ''
            },
            {
                mode: '月结｜高级',
                price: 160000,
                amt: 120000,
                qps: 20,
                excess: '1.3元/次',
                expire: '1个月',
                type: ''
            },
            {
                mode: '预付',
                price: 30000,
                amt: 10000,
                qps: 1,
                excess: '超额后需充值继续服务',
                expire: '无期限',
                type: 'prepaid'
            }
        ]
    },
    derms: {
        app_name: 'derms',
        app_img: '/images/derms_sample.png',
        // app_qrcode: '/images/derms_qrcode.jpg',
        scenarios: [
            {
                icon: 'iconface-24px1',
                title: '肤质管理',
                content: '保存肤质报告，追踪长期肌肤状态变化'
            },
            {
                icon: 'iconsearch-24px',
                title: '皮肤病早筛',
                content: '检测 15 种面部皮肤疾病风险'
            },
            {
                icon: 'iconsanitizer-24px',
                title: '产品推荐',
                content: '相关护肤产品推荐'
            },
            {
                icon: 'iconcall_split-24px',
                title: '导诊',
                content: '皮肤科、整形外科医生推荐'
            }
        ],
        prices: [
            {
                mode: '月结｜基础',
                price: 50000,
                amt: 25000,
                qps: 5,
                excess: '2元/次',
                expire: '1个月',
                type: ''
            },
            {
                mode: '月结｜中级',
                price: 90000,
                amt: 55000,
                qps: 10,
                excess: '1.6元/次',
                expire: '1个月',
                type: ''
            },
            {
                mode: '月结｜高级',
                price: 160000,
                amt: 120000,
                qps: 20,
                excess: '1.3元/次',
                expire: '1个月',
                type: ''
            },
            {
                mode: '预付',
                price: 30000,
                amt: 10000,
                qps: 1,
                excess: '超额后需充值继续服务',
                expire: '无期限',
                type: 'prepaid'
            }
        ]
    }
}